import { schema } from '@Schema/schema';
import { withDefaults } from '@Schema/utils';
import { createFileRoute, stripSearchParams } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { defaultFilters } from '@views/AssetsCoverage/assets.utils';
import { APP_PATHS, PAGE_PATHS } from '../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/vulnerabilities/asset-coverage/')({
  validateSearch: zodValidator(withDefaults(schema.ASSET_COVERAGE, defaultFilters)),
  search: {
    middlewares: [stripSearchParams(defaultFilters)],
  },
  beforeLoad: ({ context, preload }) => {
    const isAllowed = !!context.userPermissions.hasAllowedPermission({
      app: APP_PATHS.VULNERABILITIES,
      path: PAGE_PATHS.ASSET_COVERAGE,
    });
    context.validatePermissions({ isAllowed, preload });
  },
});
